import { HTMLAttributes, forwardRef } from 'react';
import { cn } from '@/lib/utils';

export type BadgeVariant =
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'default'
  // ✅ aliases ที่หน้าเพจใช้
  | 'destructive'
  | 'primary'
  | 'secondary'
  | 'purple'
  | 'error';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
}

const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant = 'default', ...props }, ref) => {
    // ✅ map alias → variant หลัก (จะได้ไม่ต้องทำสีเพิ่มเยอะ)
    const normalized: Exclude<BadgeVariant, 'destructive' | 'primary' | 'secondary' | 'purple' | 'error'> =
      variant === 'destructive' || variant === 'error'
        ? 'danger'
        : variant === 'primary'
          ? 'info'
          : variant === 'secondary'
            ? 'default'
            : variant === 'purple'
              ? 'info'
              : variant;

    const variants = {
      success: 'bg-green-100 text-green-800',
      warning: 'bg-yellow-100 text-yellow-800',
      danger: 'bg-red-100 text-red-800',
      info: 'bg-blue-100 text-blue-800',
      default: 'bg-gray-100 text-gray-800',
    };

    return (
      <span
        ref={ref}
        className={cn(
          'inline-flex items-center px-3 py-1 rounded-full text-sm font-medium',
          variants[normalized],
          className
        )}
        {...props}
      />
    );
  }
);

Badge.displayName = 'Badge';

export { Badge };
